export default __webpack_public_path__ + "static/media/introduction.6157abd8.gif";